import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionsByBudgetId: {},
};

/**
 * Shape:
 * sessionsByBudgetId[budgetId] = {
 *   initialTotal: number | null,
 *   currentTotal: number,
 *   delta: number,
 *   lastUpdatedAt: number
 * }
 */
const budgetSessionSlice = createSlice({
  name: 'budgetSession',
  initialState,
  reducers: {
    startSession: (state, action) => {
      const { budgetId, initialTotal } = action.payload || {};
      if (!budgetId) return;

      const safeInitial = Number.isFinite(initialTotal) ? initialTotal : 0;
      state.sessionsByBudgetId[budgetId] = {
        initialTotal: safeInitial,
        currentTotal: safeInitial,
        delta: 0,
        lastUpdatedAt: Date.now(),
      };
    },
    updateTotal: (state, action) => {
      const { budgetId, newTotal } = action.payload || {};
      if (!budgetId) return;

      const safeTotal = Number.isFinite(newTotal) ? newTotal : 0;
      const existing = state.sessionsByBudgetId[budgetId];

      if (!existing) {
        state.sessionsByBudgetId[budgetId] = {
          initialTotal: safeTotal,
          currentTotal: safeTotal,
          delta: 0,
          lastUpdatedAt: Date.now(),
        };
        return;
      }

      const initial = Number.isFinite(existing.initialTotal)
        ? existing.initialTotal
        : safeTotal;

      state.sessionsByBudgetId[budgetId] = {
        initialTotal: initial,
        currentTotal: safeTotal,
        delta: safeTotal - initial,
        lastUpdatedAt: Date.now(),
      };
    },
    resetSession: (state, action) => {
      const { budgetId } = action.payload || {};
      if (!budgetId) return;
      delete state.sessionsByBudgetId[budgetId];
    },
    clearAllSessions: state => {
      state.sessionsByBudgetId = {};
    },
  },
});

export const { startSession, updateTotal, resetSession, clearAllSessions } =
  budgetSessionSlice.actions;

export default budgetSessionSlice.reducer;
